import { render, staticRenderFns } from "./PricingDesktopMonthly.vue?vue&type=template&id=3449c5f1&scoped=true&"
import script from "./PricingDesktopMonthly.vue?vue&type=script&lang=js&"
export * from "./PricingDesktopMonthly.vue?vue&type=script&lang=js&"
import style0 from "./PricingDesktopMonthly.vue?vue&type=style&index=0&id=3449c5f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3449c5f1",
  null
  
)

export default component.exports